import { render, staticRenderFns } from "./QApplication.vue?vue&type=template&id=79b4ddfa&scoped=true&"
import script from "./QApplication.vue?vue&type=script&lang=js&"
export * from "./QApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b4ddfa",
  null
  
)

export default component.exports